import { Link, useNavigate } from "react-router-dom";
import logo from './../../assets/images/green_shoppictcart_1484336527-1.png'
import { useFormik } from "formik";
import { string, object } from 'yup';
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { baseUrl } from "../../utils/baseUrl.js";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext.jsx";
import { CartContext } from "../../Context/CartContext.jsx";
import { WishListContext } from "../../Context/WishListContext.jsx";
import { CheckOutContext } from "../../Context/CheckOutContext.jsx";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Login() {
    const notify = (msg, type) => toast[type](msg);
    const { saveUserToken } = useContext(AuthContext)
    const { getUserCart } = useContext(CartContext)
    const { getOrders } = useContext(CheckOutContext)
    const { getWishItems } = useContext(WishListContext)
    let navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    let validationSchema = object({
        email: string().email().required(),
        password: string().matches(/^(?=.*[A-Za-z])(?=.*\d)*([@$!%*#?&])*[A-Za-z\d@$!%*#?&.]{6,32}$/, "password must match the pattern").required(),
    });

    let registerFormik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            setIsLoading(true)
            axios.post(`${baseUrl}/auth/login`, values).then((response) => {
                if (response.data.message === "Login Done") {
                    setIsLoading(false)
                    localStorage.setItem("authorization", response.data.token);
                    notify("Sign In success", "success")
                    navigate('/')
                    saveUserToken()
                    getUserCart()
                    getWishItems()
                    getOrders()
                }
            }).catch((error) => {
                if (error.response) {
                    setIsLoading(false)
                    setErrorMessage(error.response.data.error)
                    notify(error.response.data.error, "error")
                }
            })
        }
    })

    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | Login</title>
            </Helmet>
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    <img className="mx-auto h-16 w-auto"
                        src={logo}
                        alt="Your Company"
                    />
                    <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                        Sign in to your account
                    </h2>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-lg">
                    {errorMessage ? <div className="bg-red-500 py-2 px-3 w-full text-gray-50 rounded my-2">{errorMessage}</div> : ""}
                    <form className="space-y-6" onSubmit={registerFormik.handleSubmit}>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                Email address
                            </label>
                            <div className="mt-2">
                                <input
                                    onBlur={registerFormik.handleBlur}
                                    value={registerFormik.values.email}
                                    onChange={registerFormik.handleChange} id="email" name="email" type="email"
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                            {registerFormik.errors.email && registerFormik.touched.email ?
                                <div className=" py-1 text-red-600 my-2">{registerFormik.errors.email}</div> : ""}
                        </div>

                        <div>
                            <div className="flex items-center justify-between">
                                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                                    Password
                                </label>
                                <div className="text-sm">
                                    <Link to="/forgetPass" className="font-semibold text-green-600 hover:text-green-500">
                                        Forgot password?
                                    </Link>
                                </div>
                            </div>
                            <div className="mt-2">
                                <input
                                    onBlur={registerFormik.handleBlur}
                                    value={registerFormik.values.password}
                                    onChange={registerFormik.handleChange}
                                    id="password"
                                    name="password"
                                    type="password"
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                            {registerFormik.errors.password && registerFormik.touched.password ?
                                <div className=" py-1 text-red-600 my-2">{registerFormik.errors.password}</div> : ""}
                        </div>

                        <div>
                            <button
                                type="submit" disabled={registerFormik.isValid && registerFormik.dirty && !isLoading ? false : true}
                                className={"bg-green-600 hover:bg-green-500 text-gray-50 rounded my-2 py-2 px-5 disabled:bg-green-600 disabled:opacity-40"}>{isLoading ? <i className="fas fa-spinner fa-spin"></i> : 'Sign In'}
                            </button>
                        </div>
                    </form>

                    <p className="mt-10 text-center text-sm text-gray-500">
                        Not a member?{' '}
                        <Link to="/signup" className="font-semibold leading-6 text-green-600 hover:text-green-500">
                            Sign Up
                        </Link>
                    </p>
                </div>
            </div>
        </HelmetProvider>
    )
}
